import { createFileRoute } from "@tanstack/react-router";
import { redirectRemovedAuthor } from "@/lib/removedAuthors";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import Author from "@/pages/Author";

export const Route = createFileRoute("/zh-cn/author/$slug")({
  loader: ({ params }) => (redirectRemovedAuthor(params.slug, "/zh-cn"), loadContentMeta("authors", params.slug, "zh-cn")),
  head: ({ params, loaderData }) =>
    buildContentHead(`/zh-cn/author/${params.slug}`, loaderData),
  component: Author,
});

